<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 7V5H18V3H20V1H22V3H24V5H22V7H20ZM4 21C3.45 21 2.979 20.804 2.587 20.412C2.195 20.02 1.99934 19.5493 2 19V7C2 6.45 2.196 5.979 2.588 5.587C2.98 5.195 3.45067 4.99933 4 5H7.15L9 3H15V5H9.875L8.05 7H4V19H20V10H22V19C22 19.55 21.804 20.021 21.412 20.413C21.02 20.805 20.5493 21.0007 20 21H4ZM12 17.5C13.25 17.5 14.3127 17.0623 15.188 16.187C16.0633 15.3117 16.5007 14.2493 16.5 13C16.5 11.75 16.0623 10.6873 15.187 9.812C14.3117 8.93667 13.2493 8.49933 12 8.5C10.75 8.5 9.68734 8.93767 8.812 9.813C7.93667 10.6883 7.49934 11.7507 7.5 13C7.5 14.25 7.93767 15.3127 8.813 16.188C9.68834 17.0633 10.7507 17.5007 12 17.5ZM12 15.5C11.3 15.5 10.7083 15.2583 10.225 14.775C9.74167 14.2917 9.5 13.7 9.5 13C9.5 12.3 9.74167 11.7083 10.225 11.225C10.7083 10.7417 11.3 10.5 12 10.5C12.7 10.5 13.2917 10.7417 13.775 11.225C14.2583 11.7083 14.5 12.3 14.5 13C14.5 13.7 14.2583 14.2917 13.775 14.775C13.2917 15.2583 12.7 15.5 12 15.5Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGPhoto',
};
</script>

<style scoped>

</style>